<template>
    <div class="xiangmu">
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../assets/images/fhqr.png" class="steps step1" v-if="status==1">
            <img src="../../assets/images/fhqr1.png" class="steps step2" v-if="status==2">
            <img src="../../assets/images/fhqr2.png" class="steps step3" v-if="status==3">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'内销发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '1' "/>-->
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'外销发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '2' "/>-->
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'免费订单发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '4' "/>-->
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '3' "/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
        			<div class="h-thirdColumn w-newColumn">
        				<el-form-item label="订单编号" prop="sapCodeLike" style="width: 50%;">
        				    <el-input
        				            v-model="formInline.sapCodeLike"
        				            placeholder="多订单模糊查询请用空格或分号分隔"
        				            clearable></el-input>
        				</el-form-item>
        				<el-form-item label="　　订单创建时间" prop="cdate" style="width: 50%;">
        					<el-date-picker
        						v-model="formInline.cdatebegin"
        						clearable
        						type="date"
        						value-format="yyyy-MM-dd" >
        					</el-date-picker>
        					<span class="w-time-to">至</span>
        					<el-date-picker
        						v-model="formInline.cdateend"
        						clearable
        						type="date"
        						value-format="yyyy-MM-dd" >
        					</el-date-picker>
        				</el-form-item>
        			</div>
        			<el-collapse-transition>
        				<div v-show="isScreen">
        					<div class="h-thirdColumn w-newColumn">
        						<el-form-item label="产品编码" prop="materialCodeLike">
        						    <el-input
        						            v-model="formInline.materialCodeLike"
        						            placeholder="请输入"
        						            clearable></el-input>
        						</el-form-item>
        						<el-form-item label="　售达方国家/区域" prop="soldToAreaName">
        							<el-input
        									v-model="formInline.soldToAreaName"
        									placeholder="请输入"
        									clearable></el-input>
        						</el-form-item>
        						<el-form-item label="创建人" prop="cuname">
        							<el-input
        									v-model="formInline.cuname"
        									placeholder="请输入"
        									clearable></el-input>
        						</el-form-item>
        					</div>
        				</div>
        			</el-collapse-transition>

                </el-form>
        		<div class="l-screenBox">
        			<div class="l-screen" @click="collapseChange">
        				<img :src="isScreen?closeScreen:drawScreen" alt="">
        				<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
        			</div>
        			<div class="l-retrieval">
        				<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
        				<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
        			</div>
        		</div>
            </div>
        </div>


        <div class="h-table h-mrt30" v-if="roleType=='1' ||  roleType=='4'">
            <el-table
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    stripe
            		border
                    style="width: 100%"
            		max-height="450"
            >
                <el-table-column
            			fixed
                        type="selection"
                        width="40"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                	   type="index"
                	   label="#"
                	   fixed
                	   width="40">
                </el-table-column>
                <el-table-column
                		fixed
                        prop="sapCode"
                        :show-overflow-tooltip="true"
                        label="订单编号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        :show-overflow-tooltip="true"
                        width="150">
                		<template scope="scope">
                			<div style="text-align: left;">
                				{{scope.row.soldToName}}
                			</div>
                		</template>
                </el-table-column>

                <!--
                <el-table-column
                        prop="dnStatus"
                        label="信用查询是否通过"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        {{scope.row.dnStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                -->

                <el-table-column
					prop="note"
					label="订单备注"
					:show-overflow-tooltip="true"
					width="150">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.note}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="proModelName"
					label="产品大类"
					width="100">
                </el-table-column>
                <el-table-column
					prop="materialCode"
					label="产品编码"
					:show-overflow-tooltip="true"
					width="110">
                </el-table-column>
                <el-table-column
					prop="materialName"
					label="产品型号"
					:show-overflow-tooltip="true"
					width="140">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.materialName}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="proType"
					label="型号属性"
					:show-overflow-tooltip="true"
					width="90">
                </el-table-column>
                <el-table-column
					prop="isStockUp"
					label="是否备货"
					:show-overflow-tooltip="true"
					width="90">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>
                <el-table-column
					prop="proNumber"
					label="产品数量"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.proNumber}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="availableNum"
					label="可用库存"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.availableNum}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="syNum"
					label="剩余库存"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.syNum}}
							</div>
						</template>
                </el-table-column>

                <!--
                <el-table-column
                        prop="payMethod"
                        label="付款方式"
                        width="270"
                        :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        {{`现金占用：${ scope.row.jinexj } ${ scope.row.currencyCode }`}}
                        {{`信贷占用：${ scope.row.jinexd } ${ scope.row.currencyCode }`}}
                    </template>
                </el-table-column>
                -->

                <el-table-column
					prop="cdate"
					label="审核时间"
					:show-overflow-tooltip="true"
					width="160">
                </el-table-column>

                <el-table-column
					prop="soldToAreaName"
					label="售达方国家"
					:show-overflow-tooltip="true"
					width="120">
                </el-table-column>
                <el-table-column
					prop="cdate"
					label="创建时间"
					:show-overflow-tooltip="true"
					:formatter="formatDate"
					width="160">
                </el-table-column>
                <el-table-column
					prop="cuname"
					label="创建人"
					:show-overflow-tooltip="true"
					width="80">
                </el-table-column>

                <el-table-column
					label="操作"
					width="100"
					fixed="right"
                >
                    <template slot-scope="scope">
                		<div style="display: flex;align-items: center;justify-content: flex-start;">
                			<el-button
                			        type="text"
                			        size="small"
                					style="padding: 0;"
                			        class="h-tableLink h-btn"
                			        @click="goDetails(scope.row)">
                			    查看
                			</el-button>
                			<el-button
                					style="margin-left: 0.1rem;padding: 0;"
                			        @click="send(scope.row.sapCode)"
                			        type="text"
                			        size="small"
                			        class="h-tableLink h-btn"
                			>
                			    发货
                			</el-button>
                		</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row)"></span>
							<span class="l-operationlist br-operation-fh" title="安排发货" @click="send(scope.row.sapCode)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="downloadExcel">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="allClosingTicketTime">
                        送货时间维护
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="allClosingTicket">
                       批量安排发货
                    </el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>


        <div class="h-table h-mrt30" v-if="roleType=='2' ||  roleType=='3' ||  roleType=='5' ">
            <el-table
				@selection-change="handleSelectionChange"
				:data="tableData"
				:span-method="objectSpanMethod"
				stripe
				border
				style="width: 100%"
				max-height="450"
            >
                <el-table-column
					type="selection"
					width="40"
					:label="all"
					fixed
                >
                </el-table-column>
                <el-table-column
				   type="index"
				   label="#"
				   fixed
				   width="40">
                </el-table-column>
                <el-table-column
					prop="sapCode"
					fixed
					:show-overflow-tooltip="true"
					label="订单编号"
					width="120">
                </el-table-column>
                <el-table-column
					prop="soldToName"
					label="经销商"
					:show-overflow-tooltip="true"
					min-width="180">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.soldToName}}
						</div>
					</template>
                </el-table-column>

                <!--
                <el-table-column
                        prop="dnStatus"
                        label="信用查询是否通过"
                        :show-overflow-tooltip="true"
                        width="170">
                    <template scope="scope">
                        {{scope.row.dnStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                -->

                <el-table-column
					prop="note"
					label="订单备注"
					:show-overflow-tooltip="true"
					width="110">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.note}}
						</div>
					</template>
                </el-table-column>
                <el-table-column
                	prop="proModelName"
                	label="产品大类"
                	width="100">
                </el-table-column>
                <el-table-column
					prop="materialCode"
					label="产品编码"
					:show-overflow-tooltip="true"
					width="110">
                </el-table-column>
                <el-table-column
					prop="materialName"
					label="产品型号"
					:show-overflow-tooltip="true"
					width="120">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.materialName}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="proType"
					label="型号属性"
					:show-overflow-tooltip="true"
					width="90">
                </el-table-column>
                <el-table-column
					prop="isCustommed"
					label="常规或改制"
					:show-overflow-tooltip="true"
					width="110">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isCustommed == 0">
                            常规
                        </div>
                        <div v-else>
                            改制
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
					prop="extraDes"
					label="改制描述"
					:show-overflow-tooltip="true"
					width="180">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.extraDes}}
							</div>
						</template>
                </el-table-column>

                <el-table-column
					prop="closingTicketCode"
					label="合票号"
					:show-overflow-tooltip="true"
					width="120">
                </el-table-column>
                <el-table-column
					prop="deliveryTime"
					label="要求送货时间"
					:show-overflow-tooltip="true"
					width="150">
                </el-table-column>
                <el-table-column
					prop="partsNum"
					label="备件件数"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.partsNum}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="marks"
					label="是否有唛头"
					:show-overflow-tooltip="true"
					width="110">
					<template slot-scope="scope">
						<div v-if="scope.row.marks == 1">有</div>
						<div v-if="scope.row.marks == 0">无</div>
						<div v-else></div>
					</template>
                </el-table-column>
                <el-table-column
					prop="numWeightSize"
					label="件数/重量/尺寸"
					:show-overflow-tooltip="true"
					width="140">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.numWeightSize}}
							</div>
						</template>
                </el-table-column>

                <el-table-column
					prop="boxing"
					label="装箱方式"
					:show-overflow-tooltip="true"
					width="90">
                </el-table-column>
				<!-- <el-table-column
					prop="boxNum"
					label="箱数"
					:show-overflow-tooltip="true"
					width="60">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.boxNum}}
							</div>
						</template>
				</el-table-column>

				<el-table-column
				        prop="isStockUp"
				        label="是否备货"
				        :show-overflow-tooltip="true"
				        width="90">
				    <template scope="scope">
				        {{scope.row.isStockUp|dictname('shifou_keyong')}}
				    </template>
				</el-table-column> -->
                <el-table-column
					prop="proNumber"
					label="产品数量"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.proNumber}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="availableNum"
					label="可用库存"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.availableNum}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
					prop="syNum"
					label="剩余库存"
					:show-overflow-tooltip="true"
					width="90">
						<template scope="scope">
							<div style="text-align: right;">
								{{scope.row.syNum}}
							</div>
						</template>
                </el-table-column>

                <!--
                <el-table-column
                        prop="payMethod"
                        label="付款方式"
                        width="270"
                        :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        {{`现金占用：${ scope.row.jinexj } ${ scope.row.currencyCode }`}}
                        {{`信贷占用：${ scope.row.jinexd } ${ scope.row.currencyCode }`}}
                    </template>
                </el-table-column>
                -->

                <el-table-column
					prop="sptgTime"
					label="审核时间"
					:show-overflow-tooltip="true"
					width="160">
                </el-table-column>

                <el-table-column
					prop="soldToAreaName"
					label="售达方区域/国家"
					:show-overflow-tooltip="true"
					width="150">
                </el-table-column>
                <el-table-column
					prop="cdate"
					label="创建时间"
					:show-overflow-tooltip="true"
					:formatter="formatDate"
					width="160">
                </el-table-column>
                <el-table-column
					prop="cuname"
					label="创建人"
					:show-overflow-tooltip="true"
					width="90">
                </el-table-column>

                <el-table-column
					label="操作"
					width="100"
					fixed="right"
                >
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: flex-start;">
                			<el-button
								type="text"
								size="small"
								style="padding: 0;"
								class="h-tableLink h-btn"
								@click="goDetails(scope.row)">
                			    查看
                			</el-button>

                			<el-button
								style="margin-left: 0.1rem;padding: 0;"
								@click="send(scope.row)"
								type="text"
								size="small"
								class="h-tableLink h-btn"
                			>
                			    发货
                			</el-button>
                		</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row)"></span>
							<span class="l-operationlist br-operation-fh" title="安排发货" @click="send(scope.row.sapCode)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="downloadExcel">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" v-if="roleType=='2' ||  roleType=='3' " icon="h-el-icon h-el-icon-import" @click="allClosingTicket">
                        批量安排发货
                    </el-button>
                    <!-- <el-button class="h-btn h-formBtn h-bgblueQ" v-if="roleType=='5' " icon="h-el-icon h-el-icon-import" @click="allSend">
                        批量安排发货
                    </el-button> -->
                    <el-button class="h-btn h-formBtn h-bgblueQ" v-if="roleType=='2' ||  roleType=='3' " icon="h-el-icon h-el-icon-import" @click="allClosingTicketTime">
                        发货时间维护
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" v-if="roleType=='2' ||  roleType=='3' " icon="h-el-icon h-el-icon-import" v-auth="'changeBox'" @click="allChangeBox">
                        修改装箱方式
                    </el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>

        <!-- 多单合票弹窗 -->
        <el-dialog
                :visible.sync="showClosingTicket"
                v-if="showClosingTicket"
                class="h-dialog2"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>多单合票信息维护</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">订单号:</h3>
                <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
            </div>
            <div class="h-formLine" style="padding:0.2rem 0.2rem 0 0.2rem;border-bottom: 1px dashed #ccc;">
                <!-- <div style="display: flex;justify-content: space-between;">
                    <h3 style="display: inline-block;">合票号</h3>
                    <el-input v-model="closingTicketCode" placeholder="请输入" style="width: 2rem;margin-top: 0.1rem;" />
                    <h3 style="display: inline-block;">送货时间</h3>
                    <el-date-picker
                            placeholder="请选择送货日期"
                            v-model="deliveryTime"
                            clearable
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="margin-top: 0.1rem;width: 2rem">
                    </el-date-picker>
                </div>
                <div style="display: flex;justify-content: space-between;">
                    <h3 style="display: inline-block;">备件数量</h3>
                    <el-input v-model="partsNum" placeholder="请输入" style="width: 2rem;margin-top: 0.1rem;" />
                    <h3 style="display: inline-block;">是否有唛头</h3>
                    <el-select v-model="marks" :clearable="true"
                               placeholder="请选择">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </div> -->
                <el-form :model="formInline" :rules="rules" ref="addcom" :inline="true"
                    class="demo-ruleForm h-formbLine h-dialogForm" style="padding:0;">
                    <!--<el-form-item label="合票号" class="h-elformWrap-2" prop="closingTicketCode">-->
                        <!--<el-input v-model="closingTicketCode" placeholder="请输入" />-->
                    <!--</el-form-item>-->
                    <el-form-item label="送货时间" class="h-elformWrap-2" prop="deliveryTime">
                        <el-date-picker
                                placeholder="请选择送货时间"
                                v-model="deliveryTime"
                                clearable
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备件数量" prop="partsNum" class="h-elformWrap-2">
                        <el-input v-model="partsNum" placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="是否有唛头" class="h-elformWrap-2" prop="marks">
                        <el-select v-model="marks" :clearable="true" placeholder="请选择">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">唛头格式上传</h3>
                <brupload
                         style="margin-top: 0.1rem;"
                        @filecallback="fjStatusA"
                        :refid="_.join(_.map(this.multipleSelection,'sapCode'),',')"
                        reftype="FH_MARKS"
                        :uploadflag = "true"
                        delflag/>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="multipleSelection[0].boxing == 'LCL'">
                <h3 style="display: inline-block;">拼箱信息表</h3>
                <brupload
                         style="margin-top: 0.1rem;"
                        @filecallback="fjStatusA"
                        :refid="_.join(_.map(this.multipleSelection,'sapCode'),',')"
                        reftype="FH_boxTable"
                        :uploadflag = "true"
                        delflag/>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="multipleSelection[0].boxing == 'FCL'">
                <h3 style="display: inline-block;">装箱图</h3>
                <brupload
                         style="margin-top: 0.1rem;"
                        @filecallback="fjStatusA"
                        :refid="_.join(_.map(this.multipleSelection,'sapCode'),',')"
                        reftype="FH_boxMap"
                        :uploadflag = "true"
                        delflag/>
            </div>
            <div class="h-formLine ljjtextareainput" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="multipleSelection[0].boxing == 'FCL'">
                <h3 style="display: inline-block;">件重尺</h3>
                <!-- <el-input v-model="numWeightSize" placeholder="请输入" style="width: 100%;margin-top: 0.1rem;" /> -->
        		<el-input
        		  style="width: 100%;margin-top: 0.1rem;"
        		  type="textarea"
        		  placeholder="请输入"
        		  v-model="numWeightSize">
        		</el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitClosingTicket">提 交</el-button>
            </div>
        </el-dialog>

                <!-- 多单合票弹窗修改后和批量发货合并，再拆分出单个发货维护必要的信息 -->
                <el-dialog
                        :visible.sync="showClosingTicket2"
                        v-if="showClosingTicket2"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>发货信息维护</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                        <h3 style="display: inline-block;">订单号:</h3>
                        <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhE}}</h4>
                    </div>
                    <div class="h-formLine" style="padding:0.2rem 0.2rem 0 0.2rem;border-bottom: 1px dashed #ccc;">
                        <!-- <div style="display: flex;justify-content: space-between;">
                            <h3 style="display: inline-block;">合票号</h3>
                            <el-input v-model="closingTicketCode" placeholder="请输入" style="width: 2rem;margin-top: 0.1rem;" />
                            <h3 style="display: inline-block;">送货时间</h3>
                            <el-date-picker
                                    placeholder="请选择送货日期"
                                    v-model="deliveryTime"
                                    clearable
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    style="margin-top: 0.1rem;width: 2rem">
                            </el-date-picker>
                        </div>
                        <div style="display: flex;justify-content: space-between;">
                            <h3 style="display: inline-block;">备件数量</h3>
                            <el-input v-model="partsNum" placeholder="请输入" style="width: 2rem;margin-top: 0.1rem;" />
                            <h3 style="display: inline-block;">是否有唛头</h3>
                            <el-select v-model="marks" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </div> -->
                        <el-form :model="formInline" :rules="rules" ref="addcom" :inline="true"
                            class="demo-ruleForm h-formbLine h-dialogForm" style="padding:0;">
                            <!--<el-form-item label="合票号" class="h-elformWrap-2" prop="closingTicketCode">-->
                                <!--<el-input v-model="closingTicketCode" placeholder="请输入" />-->
                            <!--</el-form-item>-->
                            <el-form-item label="送货时间" class="h-elformWrap-2" prop="deliveryTime">
                                <el-date-picker
                                        placeholder="请选择送货时间"
                                        v-model="deliveryTime"
                                        clearable
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备件数量" prop="partsNum" class="h-elformWrap-2">
                                <el-input v-model="partsNum" placeholder="请输入" />
                            </el-form-item>
                            <el-form-item label="是否有唛头" class="h-elformWrap-2" prop="marks">
                                <el-select v-model="marks" :clearable="true" placeholder="请选择">
                                    <el-option label="是" value="1"></el-option>
                                    <el-option label="否" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                        <h3 style="display: inline-block;">唛头格式上传</h3>
                        <brupload
                                 style="margin-top: 0.1rem;"
                                @filecallback="fjStatusA"
                                :refid="_.join(this.sapCodes,',')"
                                reftype="FH_MARKS"
                                :uploadflag = "true"
                                delflag/>
                    </div>
                    <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="this.ddhF == 'LCL'">
                        <h3 style="display: inline-block;">拼箱信息表</h3>
                        <brupload
                                 style="margin-top: 0.1rem;"
                                @filecallback="fjStatusA"
                                :refid="_.join(this.sapCodes,',')"
                                reftype="FH_boxTable"
                                :uploadflag = "true"
                                delflag/>
                    </div>
                    <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="this.ddhF == 'FCL'">
                        <h3 style="display: inline-block;">装箱图</h3>
                        <brupload
                                 style="margin-top: 0.1rem;"
                                @filecallback="fjStatusA"
                                :refid="_.join(_.map(this.multipleSelection,'sapCode'),',')"
                                reftype="FH_boxMap"
                                :uploadflag = "true"
                                delflag/>
                    </div>
                    <div class="h-formLine ljjtextareainput" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="this.ddhF == 'FCL'">
                        <h3 style="display: inline-block;">件重尺</h3>
                        <!-- <el-input v-model="numWeightSize" placeholder="请输入" style="width: 100%;margin-top: 0.1rem;" /> -->
                		<el-input
                		  style="width: 100%;margin-top: 0.1rem;"
                		  type="textarea"
                		  placeholder="请输入"
                		  v-model="numWeightSize">
                		</el-input>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitClosingTicket2">提 交</el-button>
                    </div>
                </el-dialog>

        <!-- 批量维护发货时间 -->
        <el-dialog
                :visible.sync="showClosingTicketTime"
                v-if="showClosingTicketTime"
                class="h-dialog2"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>多单合票信息维护</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">订单号:</h3>
                <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
            </div>
            <div class="h-formLine" style="padding:0.2rem 0.2rem 0 0.2rem;border-bottom: 1px dashed #ccc;">
                <el-form :model="formInline" :rules="rules" ref="addcom" :inline="true"
                         class="demo-ruleForm h-formbLine h-dialogForm" style="padding:0;">
                    <el-form-item label="送货时间" class="h-elformWrap-2" prop="deliveryTime">
                        <el-date-picker
                                placeholder="请选择送货时间"
                                v-model="deliveryTime"
                                clearable
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitClosingTicketTime">提 交</el-button>
            </div>
        </el-dialog>

        <!-- 批量维护装箱方式 -->
        <el-dialog
                :visible.sync="showChangeBox"
                v-if="showChangeBox"
                class="h-dialog2"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>维护装箱方式</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">订单号:</h3>
                <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
            </div>
            <div class="h-formLine qlzxfstwo" style="padding:0.2rem 0.2rem 0 0.2rem;border-bottom: 1px dashed #ccc;">
                <el-form :model="formInline" :rules="rules" ref="addcom" :inline="true"
                         class="demo-ruleForm h-formbLine h-dialogForm" style="padding:0;">
                    <el-form-item label="请选择装箱方式" class="h-elformWrap-2" prop="boxing">
                        <el-select v-model="boxing" :clearable="true" placeholder="请选择">
                            <el-option label="FCL" value="FCL"></el-option>
                            <el-option label="LCL" value="LCL"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
			<div slot="footer" class="dialog-footer">
			    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
			    <el-button class="h-btn h-bBtn" @click="submitChangeBox">提 交</el-button>
			</div>
        </el-dialog>

    </div>
</template>
<script>

    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				ddhB:'',
				ddhE:'',
				ddhF:'',
				ddhG:'',
                // 新手引导页
                showOrhide: false,
                status: 1,
                checked: true,
                toshow: "orderNxSend1",
                //内外销区分
                roleType: '2',
                //当前登陆人的权限列表
                rolelist: [],
                instid: null,
                showhistory: null,
                imgflag3: false,
                orderTypeList: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                spanArr: [],
                //表单
                formInline: {
                    orderCategory: '',
                    sapCodeLike: '',
                    materialCodeLike: '',
                    payMethodLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    oid: '',
                    materialCode: '',
                    payMethod: '',
                    ids: '',
                    orderStatus: '',
                    cuname: '',
                    cdatebegin: '',
                    cdateend: '',
                    soldToAreaName: '',
                    flagWx: '2',

                    closingTicketCode: null,
                    deliveryTime: null,
                    partsNum: null,
                    marks: null,
                    boxing: null,
                    numWeightSize: null,
                },
                all: '全部',
                showClosingTicket: null,
                showClosingTicketTime: null,
                showClosingTicket2: null,
                showChangeBox:null,
                closingTicketCode: null,
                deliveryTime: null,
                partsNum: null,
                marks: null,
                boxing: null,
                numWeightSize: null,
                //表格
                multipleSelection: [],
                tableData: [],
                sapCodes: [],
                clickActive: 1,
                rules:{
                    closingTicketCode:[
                        { required: true, message: '请填写合票号', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},

            allClosingTicket() {
                if(this.ddhB == ''){
                    this.$msg.msge("请勾选以上订单!!!");
                    return false;
                }
                var flag1 = true;
                //console.log('???', this.multipleSelection[0]);
                console.log('???', this.multipleSelection);
                var flag0 = true;
                var sapCodeString = "";
                this.multipleSelection.forEach((item, index) => {
                    if(null!=item.orderCategory&&('2'===item.orderCategory||2===item.orderCategory)&&('27'===item.orderCategory1||27===item.orderCategory1)){
                        flag0 = false;
                        sapCodeString=item.sapCode;
                        return;
                    }
                })
                if(!flag0){
                    this.$msg.msge("销售订单："+sapCodeString+"，为6200销售订单，6200销售订单不需要填写送货信息；如果发货，请点击操作栏的“发货”按钮发货。");
                    return;
                }

                var box = this.multipleSelection[0].boxing;
                this.multipleSelection.forEach((item, index) => {
                    if(item.boxing != box){
                        flag1 = false;
                        return;
                    }
                })
                if(!flag1){
                    this.$msg.msge("所选订单装箱方式不同，无法合票!");
                    return;
                }
                this.showClosingTicket = true;
            },

            allClosingTicketTime() {
                if(this.ddhB == ''){
                    this.$msg.msge("请勾选以上订单!!!");
                    return false;
                }
                var flag0 = true;
                var sapCodeString = "";
                this.multipleSelection.forEach((item, index) => {
                    if(null!=item.orderCategory&&('2'===item.orderCategory||2===item.orderCategory)&&('27'===item.orderCategory1||27===item.orderCategory1)){
                        flag0 = false;
                        sapCodeString=item.sapCode;
                        return;
                    }
                })
                if(!flag0){
                    this.$msg.msge("销售订单："+sapCodeString+"，为6200销售订单，6200销售订单不需要维护送货时间；如果发货，请点击操作栏的“发货”按钮发货。");
                    return;
                }
                var flag1 = true;
                //console.log('???', this.multipleSelection[0]);
                var box = this.multipleSelection[0].boxing;
                this.multipleSelection.forEach((item, index) => {
                    if(item.boxing != box){
                        flag1 = false;
                        return;
                    }
                })
                if(!flag1){
                    this.$msg.msge("所选订单装箱方式不同，无法合票!");
                    return;
                }
                this.showClosingTicketTime = true;
            },

            allChangeBox() {
                if(this.ddhB == ''){
                    this.$msg.msge("请勾选要修改的订单!!!");
                    return false;
                }
                var flag1 = true;
                var sapCodeString = "";
                this.multipleSelection.forEach((item, index) => {
                    if(null!=item.orderCategory&&('2'===item.orderCategory||2===item.orderCategory)&&('27'===item.orderCategory1||27===item.orderCategory1)){
                        flag1=false;
                        sapCodeString=item.sapCode;
                        return;
                    }
                })
                if(flag1){
                    this.showChangeBox = true;
                }else{
                    this.$msg.msge("销售订单："+sapCodeString+"，为6200销售订单，6200销售订单不需要维护装箱方式；如果发货，请点击操作栏的“发货”按钮发货。");
                }

            },

            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null) {
                    return null
                }
                let dt = new Date(data)
                return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
            },

            cancel(){
                this.showClosingTicket = false;
                this.showClosingTicketTime = false;
                this.showClosingTicket2 = false;
                this.showChangeBox = false;
                this.closingTicketCode = null;
                this.deliveryTime = null;
                this.partsNum = null;
                this.marks = null;
                this.boxing = null;
                this.numWeightSize = null;
            },

            submitClosingTicket(){
                var ids = _.join(_.map(this.multipleSelection,"id"),",");
                var orderM = {
                    id : ids,
                    closingTicketCode : this.closingTicketCode,
                    deliveryTime : this.deliveryTime,
                    partsNum : this.partsNum,
                    marks : this.marks,
                    numWeightSize : this.numWeightSize,
                };
                console.log('orderM', orderM);
                ss.OrderMainService.updateByModelW(orderM).then(rd => {
                    console.log("1111111222",rd)
                    // this.$msg.msgs(rd.msg);
                    this.sendAll();
                    // this.query();
                    this.showClosingTicket = false
                });
                this.closingTicketCode = null;
                this.deliveryTime = null;
                this.partsNum = null;
                this.marks = null;
                this.numWeightSize = null;
            },

            submitClosingTicketTime(){
                var ids = _.join(_.map(this.multipleSelection,"id"),",");
                var orderM = {
                    id : ids,
                    closingTicketCode : this.closingTicketCode,
                    deliveryTime : this.deliveryTime,
                    partsNum : this.partsNum,
                    marks : this.marks,
                    numWeightSize : this.numWeightSize,
                };
                console.log('orderM', orderM);
                ss.OrderMainService.updateByModelW(orderM).then(rd => {
                    console.log("1111111222",rd)
                    this.$msg.msgs(rd.msg);
                    this.query();
                    this.showClosingTicketTime = false
                });
                this.closingTicketCode = null;
                this.deliveryTime = null;
                this.partsNum = null;
                this.marks = null;
                this.numWeightSize = null;
            },

                    submitClosingTicket2(){
                        var ids = this.ddhG;
                        var orderM = {
                            id : ids,
                            closingTicketCode : this.closingTicketCode,
                            deliveryTime : this.deliveryTime,
                            partsNum : this.partsNum,
                            marks : this.marks,
                            numWeightSize : this.numWeightSize,
                        };
                        console.log('orderM', orderM);
                        ss.OrderMainService.updateByModelW(orderM).then(rd => {
                            console.log("ddhE", this.ddhE)
                            var sapIds = [];
                            sapIds.push(this.ddhE);
                            this.sapCodes = sapIds;
                            ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd2 => {
                                this.$msg.msgs(rd2.msg);
                                this.query();
                            });
                            this.showClosingTicket2 = false
                        });
                        this.closingTicketCode = null;
                        this.deliveryTime = null;
                        this.partsNum = null;
                        this.marks = null;
                        this.numWeightSize = null;
                    },

            submitChangeBox() {
                var ids = _.join(_.map(this.multipleSelection,"id"),",");
                var orderM = {
                    id : ids,
                    boxing : this.boxing,
                };
                console.log("orderM", orderM);
                ss.OrderMainService.updateByModelBox(orderM).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                    this.showChangeBox = false
                });
                this.boxing = null;
            },


            fjStatusA() {
                var saps = _.join(_.map(this.multipleSelection,"sapCode"),",");
                //console.log('saps', saps);
                ss.OrderMainService.updateFjStatusA(saps).then(rd => {
                });
            },

            showzhezhao() {
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if (rd == false) {
                        this.showOrhide = false;
                    } else {
                        this.showOrhide = true;
                    }
                })
            },
            //查看详情跳转
            goDetails(row) {
                var instid = null;
                if (row.orderCategory == '1') {
                    instid = row.binstid;
                } else {
                    instid = row.instid;
                }
                if (row.orderCategory == '1') {
                    this.$router.push({
                        path: "/dingdmain/orderNxshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    })
                } else {
                   if(row.orderCategory1 == '28'){
                        this.$router.push({
                            path: "/dingdmain/orderWxToHKshenpi",
                            query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                        })
                    }else{
                        this.$router.push({
                            path: "/dingdmain/orderWxshenpi",
                            query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                        })
                    }
                }
            },
            // 重置按钮
            resetData() {
                this.formInline.sapCodeLike = "";
                this.formInline.materialCodeLike = "";
                this.formInline.payMethodLike = "";
                this.formInline.cuname = "";
                this.formInline.cdatebegin = "";
                this.formInline.cdateend = "";
                this.formInline.soldToAreaName = "";
                this.query();
            },

            //查询该用户及所有子用户所有订单详情

            query() {
                this.formInline.orderCategory1 = this.roleType == '4' ? '6' : null;
                ss.OrderMainService.selectStockPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.tableData.forEach((item, index) => {
                        item.moneybackStatus = item.moneybackStatus == '2' ? '0' : item.moneybackStatus;
                        item.availableNum = item.availableNum || 0;
                        item.syNum = item.availableNum;
                        if(item.zhiliangyijian){
                            item.note = (item.note ? '订单备注:' + item.note + ';' : '') + '   质量部门意见:' + item.zhiliangyijian
                        }
                    })
                    console.log('我在这儿呀', this.tableData);
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].sapCode === this.tableData[index - 1].sapCode) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                if (column.label == '经销商' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (column.label == '订单编号' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if ((column.label == '付款方式' || column.label == '操作') &&
                    (row.status == '10' || row.orderCategory == '2')) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //导出Excel
            downloadExcel() {
                this.$msg.confirm("确认导出?", () => {
                    var idlist = [];
                    this.multipleSelection.forEach(element => {
                        idlist.push(element.sapCode);
                    });
                    var q = this.formInline;
                    if (idlist) {
                        q.id = idlist.join(",");
                    } else {
                        q.id ='';
                    }
                    console.log("q", q);
                    updownfile.down("/api/swyl/v1/dingdmain/getOrderExcelB", q, "post", 'params');
                })
            },

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                var str = '';
                this.multipleSelection.forEach(element => {
                    element.syNum = element.availableNum - element.proNumber;
                    str += element.sapCode + ',';
                });
                str = str.substring(0,str.length-1);
                this.ddhB = str;
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //安排发货方法
            send(x) {
                console.log("x",x);
                console.log("this.sapCodes",this.sapCodes);
                var sapIds = [];
                sapIds.push(x.sapCode);
                this.sapCodes = sapIds;
                var ids = x.id;
                var orderM = {
                    id : ids,
                    closingTicketCode : this.closingTicketCode,
                    deliveryTime : this.deliveryTime,
                    partsNum : this.partsNum,
                    marks : this.marks,
                    numWeightSize : this.numWeightSize,
                };
                console.log('orderM', orderM);
                if(null!=x.orderCategory&&('2'===x.orderCategory||2===x.orderCategory)&&('27'===x.orderCategory1||27===x.orderCategory1)){
                    this.$msg.confirm("确认发货?", () => {
                        ss.OrderMainService.updateByModelW(orderM).then(rd => {
                            ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd2 => {
                                this.$msg.msgs(rd2.msg);
                                this.query();
                            });
                        });
                    })
                }else{


//                this.$msg.confirm("确认发货?", () => {
//                    ss.OrderMainService.confirmSend(x).then(rd => {
//                        this.$msg.msgs(rd.msg);
//                        this.query();
//                   });
//                })
                    this.ddhE = x.sapCode;
                    this.ddhF = x.boxing;
                    this.ddhG = x.id;
                    this.showClosingTicket2 = true;
                }
            },

            allSend() {
                if(this.ddhB == ''){
                    this.$msg.msge("请勾选以上订单!!!");
                    return false;
                }
                var sapIds = [];
                this.multipleSelection.forEach(element => {
                    if(null!=element.orderCategory&&('2'===element.orderCategory||2===element.orderCategory)&&('27'===element.orderCategory1||27===element.orderCategory1)){

                    }
                    sapIds.push(element.sapCode);
                });
                this.sapCodes = sapIds;
                var ids = _.join(_.map(this.multipleSelection,"id"),",");
                var orderM = {
                    id : ids,
                    closingTicketCode : this.closingTicketCode,
                    deliveryTime : this.deliveryTime,
                    partsNum : this.partsNum,
                    marks : this.marks,
                    numWeightSize : this.numWeightSize,
                };
                console.log(this.sapCodes,"this.sapCodesthis.sapCodesthis.sapCodes")
                this.$msg.confirm("确认发货?", () => {
                     ss.OrderMainService.updateByModelW(orderM).then(rd => {
                        ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd2 => {
                            this.$msg.msgs(rd2.msg);
                            this.query();
                        });
                     });
                })
            },

            //批量安排发货
            sendAll() {
                // this.$msg.confirm("确认批量发货?", () => {
                    var sapIds = [];
                    this.multipleSelection.forEach(element => {
                        sapIds.push(element.sapCode);
                    });
                    this.sapCodes = sapIds;
                    console.log(this.sapCodes,"this.sapCodesthis.sapCodesthis.sapCodes")
                    ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                // })
            },


            getRole() {
                this.rolelist = this._user.roles;
                console.log('我在这儿呀', this.rolelist);
                this.rolelist.forEach(elements => {
                    if (elements.id == "swyl_dingdgly") {
                        this.roleType = '1';
                    }
                    if (elements.id == "swyl_waixiaogly" || elements.id == "swyl_wxddgly_hsj"|| elements.id == "swyl_xiaoshoujl_wx_hsj") {
                        this.roleType = '2';
                    }
                    if (elements.id == "swyl_admin") {
                        this.roleType = '3';
                    }
                    if (elements.id == "mianfei_zhuanyuan") {
                        this.roleType = '4';
                    }
                    if (elements.id == "swyl_haiwai_ckgly") {
                        this.roleType = '5';
                    }

                });
            },
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i) {
                if (this.status == 1) {
                    this.status = 2;
                } else if (this.status == 2) {
                    this.status = 3;
                } else if (this.status == 3) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            }
        },
        created() {
            this.showzhezhao()
            this.getRole();
            this.query();
        },
        beforeCreate() {

        },
        mounted() {
        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

</style>
<style>
.qlzxfstwo .h-dialogForm .h-elformWrap-2 .el-form-item__label{
    width: 44%;
}
.qlzxfstwo .h-dialogForm .h-elformWrap-2 .el-form-item__content{
    width: 56%;
}
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 0.8rem;
            left: 0rem;
            width: 4.9rem;
            height: 8rem;
        }

        .step2 {
            top: 1.65rem;
            left: 2.8rem;
            width: 10.2rem;
            height: 1.85rem;
        }

        .step3 {
            top: 3.65rem;
            right: 0.8rem;
            width: 5rem;
            height: 1rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
<style>
	.ljjtextareainput .el-textarea__inner{
		resize: none;
		height: 1rem;
	}
</style>
